<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="country-wrap">
                            <div class="img">
                                <img :src="require(`./../../assets/image/putInStorage/${$store.state.record.country}-flag.png`)"
                                     alt="">
                            </div>
                            <div class="img">
                                <img :src="$store.state.record.template.image" alt="">
                            </div>
                            <div class="info">
                                最佳货物总数：{{amount}}件 , 请按照1：1比例分配A、B仓库
                            </div>
                        </div>
                        <div class="storage-wrap">
                            <div class="item" v-for="(item,index) in list"
                                 :key="index">
                                <div class="img">
                                    <img src="../../assets/image/putInStorage/ASpace-putin.png" alt="" v-if="index===0">
                                    <img v-else src="../../assets/image/putInStorage/BSpace-putin.png" alt="">
                                </div>
                                <span class="btn">
                                    <input type="number" placeholder="分配货物数量" v-model="item.amount" @focus="error=false" >
                                    <i v-if="item.amount != amount/2 && error" class="iconfont icon-wrong animate__flash"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" @click="$router.push($route.meta.prev)">
                    上一步
                </span>
                <span class="btn" @click="next">
                    申请入仓
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
                count: '',
                Already: false,
                error:false,
            }
        },
        computed: {
            amount() {
                return this.$store.state.record.country === 'MY' ? 30000 : 6000
            }
        },
        created() {
            this.getList()
        },
        methods: {
            next(){
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].amount != this.amount/2){
                        this.error = true;
                        return false;
                    }
                }
                let $post = [];
                this.list.forEach(item=>{
                    let post = new Promise((resolve,reject)=>{
                        this.axios.post('/student/store/exp/in/apply/in', {
                            experiment: {id: this.$store.state.record.experiment.id},
                            storeExp: {id: item.id},
                            product: {id: this.$store.state.record.template.id},
                            amount: item.amount
                        }).then(res=>{
                            resolve(res)
                        })
                    })
                    $post.push(post)
                })
                Promise.all($post).then(res=>{
                    let arr = {};
                    for(let i=0;i<res.length;i++){
                        if(res[i].succeed && res[i].login){
                            arr[res[i].storeExpIn.storeExp.store.name] = res[i].storeExpIn
                        }else {
                            return false
                        }
                    }
                    this.$store.commit('setState', {key: `record.store`, value: arr})
                    this.$swal({
                        text:'入仓申请成功',
                        icon:'success',
                        confirmButtonText: '下一步'
                    }).then(res=>{
                        this.$router.push(this.$route.meta.next)
                    });
                })
            },
            getList() {
                this.axios.post('/student/store/exp/list', {experiment: {id: this.$store.state.record.experiment.id}}).then(res => {
                    if (res.succeed && res.login) {
                        this.list = res.items.filter((item, index) => {
                            item.amount = '';
                            return item.store.country === this.$store.state.record.country
                        });
                    }
                })
            },
            setStore(item) {
                this.$store.commit('setState', {key: 'record.store', value: item})
            },
            putIn() {

            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .main-area-box {
                    width: 1038px;

                    .country-wrap {
                        padding: 26px 0;
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #2c3e50;


                        .img {
                            width: 165px;
                            height: 133px;
                            margin-right: 56px;

                            > img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                        .info {
                            font-size: 18px;
                            font-weight: bolder;
                            color: red;
                        }
                    }

                    .storage-wrap {
                        display: flex;
                        justify-content: space-between;
                        padding: 26px 0;

                        div.item {
                            display: flex;
                            align-items: center;
                            height: 222px;
                            width: 50%;

                            &.active {
                                span.btn {
                                    background-color: #FBB521;
                                }
                            }

                            > .img {
                                width: 295px;
                                height: 222px;
                                margin-right: 30px;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }

                            span.btn {
                                color: #FFFFFF;
                                border-radius: 50px;
                                padding: 6px;
                                background: #9e9e9e;
                                transition: background-color 0.2s ease-in-out;
                                position: relative;
                                input {
                                    outline: none;
                                    border:none;
                                    height: 28px;
                                    border-radius: 50px;
                                    padding: 0 10px;
                                }
                                @keyframes flashh {
                                    0%{
                                        opacity: 1;
                                    }
                                    50% {
                                        opacity: 0;
                                    }
                                    100% {
                                        opacity:1;
                                    }
                                }
                                i {
                                    font-size: 30px;
                                    color: red;
                                    position: absolute;
                                    right: 0;
                                    top: 0;
                                    animation-iteration-count:3;
                                    animation-name: flashh;
                                    animation-fill-mode: both;
                                    animation-duration: 1s;
                                }
                            }
                        }
                    }

                    .line {
                        width: 100%;
                        height: 1px;
                        background: #2c3e50;
                        margin: 48px 0;
                    }

                    .putin-wrap {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 133px;
                        padding-left: 20px;
                        margin-bottom: 20px;

                        .item {
                            width: 50%;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            height: 222px;

                            .img {
                                width: 165px;
                                height: 133px;
                                margin-right: 56px;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }
                        }

                        .input-box {
                            width: 295px;
                            margin-right: 30px;
                        }

                        span.btn {
                            cursor: pointer;
                            color: #FFFFFF;
                            border-radius: 50px;
                            padding: 12px 28px;
                            background: #FBB521;
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
